import { render, staticRenderFns } from "./MemberVotingConfirmation.vue?vue&type=template&id=5b633fd7&scoped=true"
import script from "./MemberVotingConfirmation.vue?vue&type=script&lang=js"
export * from "./MemberVotingConfirmation.vue?vue&type=script&lang=js"
import style0 from "./MemberVotingConfirmation.vue?vue&type=style&index=0&id=5b633fd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b633fd7",
  null
  
)

export default component.exports